import { UPDATE_MISMATCH_REQUEST_STATUS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';
import { IRaiseMismatch } from '../mismatch-requests/getMismatchRequests';

interface UpdateMismatchRequestStatusResponse {
  success: boolean;
  data?: IRaiseMismatch;
  message?: string;
}

interface UpdateMismatchRequestStatusPayload {
  _id: string;
  status: IRaiseMismatch['status'];
}

const updateMismatchRequestStatus = async (
  payload: UpdateMismatchRequestStatusPayload
): Promise<UpdateMismatchRequestStatusResponse> => {
  try {
    const response = await makeAuthenticatedRequest(
      UPDATE_MISMATCH_REQUEST_STATUS,
      {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      }
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export {
  updateMismatchRequestStatus,
  type UpdateMismatchRequestStatusPayload,
  type UpdateMismatchRequestStatusResponse,
};
